import React from 'react';
import AdminPublishingChannels from './AdminPublishingChannels';
import AdminSavedLinks from './AdminSavedLinks';
import { SOCIAL_PUBLISHING_ENABLED } from '../../config/socialPublishing';

interface AdminOnlinePresenceTabProps {
  location: any;
  tenantId?: string;
  /** The location REQUEST id (route param) — the OAuth callback returns to this page. */
  requestId?: string;
  /** The real `loc_...` id; absent while the request is still pending approval. */
  locationId?: string | null;
}

/**
 * Online Presence v2 (white, ruby-on-white) — same structure as platform-app OnlinePresenceTab.
 * Desktop ~85% of the page width; phone layout full width. No "View social posts" link: super
 * admin has no social posts page.
 */
const AdminOnlinePresenceTab: React.FC<AdminOnlinePresenceTabProps> = ({ location, tenantId, requestId, locationId }) => (
  <div className="w-full lg:w-[85%] mx-auto">
    {!SOCIAL_PUBLISHING_ENABLED ? (
      <AdminSavedLinks location={location} />
    ) : tenantId && requestId && locationId ? (
      <AdminPublishingChannels tenantId={tenantId} requestId={requestId} locationId={locationId} location={location} />
    ) : (
      <div className="space-y-4">
        <div className="bg-white rounded-xl border border-stone-200 p-5 text-sm text-stone-600">
          Publishing channels are available once this location is approved.
        </div>
        {/* Pending requests keep the read-only list of saved links they always showed. */}
        <AdminSavedLinks location={location} />
      </div>
    )}
  </div>
);

export default AdminOnlinePresenceTab;
